import { project } from 'CONFIG/config';

/**
 * 默认图片数据,统一全部项目默认图片信息
 * param {name}, 图片名称
 */
const dfImg = (name) => {
  let str = name || 'empty';

  return require(`../img/${project}/${str}.png`);
}

export {
  dfImg
}